import * as React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { PageHeader } from '@/components/ui/page-header';
import { buttonVariants } from '@/components/ui/button-variants';

/**
 * Rendered for a URL that matches no route: `router.tsx`'s trailing `*`
 * route, and `RouteErrorPage` when `useRouteError()` is a 404
 * `ErrorResponse`.
 *
 * It stays inside `AppLayout` (sidebar and header keep rendering around it),
 * which is why it is a plain page and not a full-screen takeover: someone
 * who mistyped a URL is still in the product and should be able to use the
 * menu to get where they meant to go, not just the one button below.
 */
export function NotFoundPage(): React.JSX.Element {
  return (
    <PageHeader
      title="No encontramos esta página"
      description="Puede que el enlace esté mal escrito o que la página ya no exista."
      actions={
        <Link to="/get-started" className={cn(buttonVariants({ variant: 'default' }))}>
          Ir a Empezar aquí
        </Link>
      }
    />
  );
}
